import {html, css, LitElement, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';

class KeliBrowseBlankSlate extends LitElement {
  static styles = css`
      :host {
          display: block;
          text-align: center;
          box-sizing: border-box;
          color: var(--keli-text);
          width: 100%;
      }

      p:first-of-type {
          margin-top: 2em !important;
      }

      p {
          margin: 0 auto 1.5em auto !important;
          max-width: 450px;
      }

      .error {
          color: var(--keli-invalid-text);
      }

      #insertButtonContainer {
          display: none;
      }

      #insertButtonContainer.visible {
          display: block;
      }
  `;

  static properties = {
    error: {type: Object},
    enabled: {type: Boolean},
    filtered: {type: Boolean},
    insertEnabled: {type: Boolean},
    keliTargetScopeRoot: {type: Object},
    rows: {type: Number}
  };

  render() {
    const visible = ((this.enabled && this.rows === 0) || this.error !== undefined);
    if (!visible) {
      return nothing;
    }

    const textClasses = {error: !!this.error};
    const buttonClasses = {visible: this.insertEnabled && !this.error};
    return html`
        <p class=${classMap(textClasses)}>
            <strong>${this._header()}</strong>
            ${this._body()}
        </p>

        <p id="insertButtonContainer" class=${classMap(buttonClasses)}>
            <keli-button id="insertButton"
                         keliname="browseinsertnewrecord"
                         caption="Create a new record"
                         design="raised"
                         background="700"
                         prevent-adjacent-element
                         .keliTargetScopeRoot=${this.keliTargetScopeRoot}>
            </keli-button>
        </p>`;
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.error = null;
    this.keliTargetScopeRoot = null;
  }

  _header() {
    if (this.error) {
      return `There was an error loading this data.`;
    }
    if (this.filtered) {
      return `Nothing matches your filter.`;
    }
    return `There's nothing here yet.`;
  }

  _body() {
    if (this.error) {
      return this.error.message;
    }

    if (this.insertEnabled) {
      if (this.filtered) {
        return `Try a less specific search, or add something new. Your new record will instantly be secure and searchable.`;
      } else {
        return `Try adding something new. Your new record will instantly be secure and searchable.`;
      }
    } else {
      if (this.filtered) {
        return `Try a less specific search.`;
      }
    }
  }
}

customElements.define('keli-browse-blank-slate', KeliBrowseBlankSlate);
